import React, {useState, useEffect} from "react";
import '../styles.css';

export default function Categories(){
    
    const[categories,setCategories] = useState([]);

    

    useEffect(()=>{
        const c = ["a","b","c"] 
        setCategories(c);
    }, []);
    

    return(
    <div>{categories.length}
     </div>);
}

